module.exports = __webpack_public_path__ + "img/Rhenusmydelivery_Kontaktblock_Image.852d849a.jpg";